import { openBlobFile } from "@/utils/utils";
import { useMutation } from "@tanstack/react-query";
import { AxiosPromise } from "axios";

export const ATTACHMENTS_QUERY_KEYS = {
  openAttachment: () => ["openAttachment"],
};

export type OpenAttachmentRequest = {
  download: () => AxiosPromise<Blob>;
  forceSave?: boolean;
};

export const useOpenAttachment = () => {
  return useMutation({
    mutationKey: ATTACHMENTS_QUERY_KEYS.openAttachment(),
    meta: { globalSpinner: false },
    mutationFn: async ({ download, forceSave }: OpenAttachmentRequest) => ({
      saved: openBlobFile(await download(), forceSave),
    }),
  });
};
